module.exports = __webpack_public_path__ + "img/10-01_Unifying People.9ba1516d.svg";